// extracted by mini-css-extract-plugin
export default {"container":"Approvals_container__F0QVJ"};